import type { Transaction } from '../../../services/transactionApi';

/**
 * Each member's part of the group's spending in a list of expenses: their
 * shares, or the whole amount for the payer when nothing was split.
 * Cancelled entries don't count, as in the month's totals.
 */
export const partsByMember = (expenses: Transaction[]): Map<string, number> => {
  const parts = new Map<string, number>();
  const add = (userId: string, amount: number) => parts.set(userId, Math.round(((parts.get(userId) ?? 0) + amount) * 100) / 100);
  expenses
    .filter((transaction) => transaction.type === 'expense' && transaction.status !== 'cancelled')
    .forEach((transaction) => {
      const shares = transaction.shares ?? [];
      if (shares.length) {
        shares.forEach((share) => add(share.userId, Number(share.amount) || 0));
      } else {
        add(transaction.paidByUserId ?? transaction.userId, Number(transaction.amount) || 0);
      }
    });
  return parts;
};
